import React from 'react';
import { Link } from 'react-router-dom';

export default function HomeProjects() {
    const projects = [
        {
            id: 1,
            title: "INDUSTRIAL HOOD",
            description: "Down Draft Hoods - Water Mist Hood - UV Hood - Odor Control Hood - Condensate Hood",
            image: "/assets/kitchenhood.png"
        },
        {
            id: 2,
            title: "INDUSTRIAL DISHWASHERS",
            description: "Utensilwashers - Rack conveyor dishwashers- Flight type dishwashers - Hood-type dishwashers- Under counter dishwashers",
            image: "/assets/dishwasher.png"
        },
        {
            id: 3,
            title: "INDUSTRIAL REFRIGERATION",
            description: "Bar Refrigeration - Chef Bases - Reach-In Refrigeration -Ice machines - Under counters & Worktops - Food Prep Tables",
            image: "/assets/refrigeration.png"
        },
    ];

    return (
        <div className="bg-gray-100 py-16 relative overflow-hidden">
            <style>
                {`
                    .cta {
                        position: relative;
                        margin: auto;
                        padding: 12px 18px;
                        transition: all 0.2s ease;
                        border: none;
                        background: none;
                        cursor: pointer;
                    }

                    .cta:before {
                        content: "";
                        position: absolute;
                        top: 0;
                        left: 0;
                        display: block;
                        border-radius: 50px;
                        background: #b1dae7;
                        width: 45px;
                        height: 45px;
                        transition: all 0.3s ease;
                    }

                    .cta span {
                        position: relative;
                        font-family: "Ubuntu", sans-serif;
                        font-size: 18px;
                        font-weight: 700;
                        letter-spacing: 0.05em;
                        color: #234567;
                    }

                    .cta svg {
                        position: relative;
                        top: 0;
                        margin-left: 10px;
                        fill: none;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke: #234567;
                        stroke-width: 2;
                        transform: translateX(-5px);
                        transition: all 0.3s ease;
                    }

                    .cta:hover:before {
                        width: 100%;
                        background: #b1dae7;
                    }

                    .cta:hover svg {
                        transform: translateX(0);
                    }

                    .cta:active {
                        transform: scale(0.95);
                    }
                `}
            </style>

            {/* Geometric Shapes Background */}
            {/* <div className="absolute top-0 right-0 w-48 h-48">
                <div className="absolute top-8 right-8 w-24 h-24 bg-blue-200 opacity-30 clip-triangle"></div>
                <div className="absolute top-4 right-4 w-16 h-16 bg-blue-300 opacity-30 clip-hexagon"></div>
                <div className="absolute top-12 right-2 w-12 h-12 bg-blue-400 opacity-30 clip-triangle"></div>
            </div> */}
            <div className="absolute bottom-0 left-0 w-48 h-48">
                <div className="absolute bottom-8 left-8 w-24 h-24 bg-blue-200 opacity-30 clip-hexagon"></div>
                <div className="absolute bottom-4 left-4 w-16 h-16 bg-blue-300 opacity-30 clip-triangle"></div>
            </div>

            <div className="container mx-auto px-4 md:px-16 relative z-10">
                <h1 className="text-4xl font-bold text-indigo-900 mb-10 text-center">Our Products</h1>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-14">
                    {projects.map((project) => (
                        <div
                            key={project.id}
                            className="bg-white rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:shadow-xl hover:scale-105"
                        >
                            <div className="h-48 overflow-hidden">
                                <img
                                    src={project.image}
                                    alt={project.title}
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <div className="p-6">
                                <h3 className="text-xl font-semibold text-indigo-900 mb-2 line-clamp-2">{project.title}</h3>
                                <p className="text-gray-600 line-clamp-3">{project.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <Link to={'/products'} className="pt-10 flex justify-end">
                    <button className="cta flex items-center">
                        <span>View All</span>
                        <svg width="15px" height="10px" viewBox="0 0 13 10">
                            <path d="M1,5 L11,5"></path>
                            <polyline points="8 1 12 5 8 9"></polyline>
                        </svg>
                    </button>
                </Link>
            </div>

            {/* CSS for geometric shapes */}
            <style>
                {`
                    .clip-triangle {
                        clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
                    }
                    .clip-hexagon {
                        clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
                    }
                `}
            </style>
        </div>
    );
}